import { ArrowUpRight, Aperture } from "lucide-react";
import { Seo } from "../components/Seo";
import { PageHeader } from "../components/Bits";
import { Reveal } from "../components/Reveal";
import { PhotoGrid } from "../components/PhotoGrid";
import { EVENT, SPONSORS } from "../lib/site";

const APERTURE_URL = SPONSORS.find((s) => s.name === "Aperture").url;

export default function Gallery() {
  return (
    <>
      <Seo title="Photo Gallery" path="/gallery" description="288 race-day photos from the Grimsby On The Lake Turkey Trot, captured by Aperture." />
      <section className="mx-auto max-w-7xl px-5 sm:px-8 pt-28 sm:pt-32 pb-4">
        <Reveal>
          <a href={APERTURE_URL} target="_blank" rel="noopener noreferrer" className="group block relative overflow-hidden rounded-[2rem] bg-black text-cream shadow-warm-lg px-8 py-14 sm:px-16 sm:py-20" data-testid="media-sponsor-feature">
            <div className="absolute inset-0 bg-[radial-gradient(60%_80%_at_70%_50%,rgba(214,140,60,0.22),transparent)] transition-opacity duration-500 group-hover:opacity-100 opacity-80" />
            <div className="relative grid gap-10 lg:grid-cols-12 items-center">
              <div className="lg:col-span-5">
                <p className="inline-flex items-center gap-2 font-accent text-2xl text-ochre"><Aperture size={20} /> official media sponsor</p>
                <h2 className="mt-3 font-display font-semibold tracking-tight text-4xl sm:text-5xl">Every moment, captured.</h2>
                <p className="mt-4 text-cream/70 leading-relaxed max-w-md">
                  Race-day photos and video for the {EVENT.shortName} are brought to you by Aperture, our official media sponsor. Look for their crew along the course and at the finish line.
                </p>
                <span className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-ochre group-hover:text-cream transition-colors duration-200">
                  Visit Aperture <ArrowUpRight size={16} className="transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </span>
              </div>
              <div className="lg:col-span-7 flex items-center justify-center rounded-3xl border border-white/10 bg-white/[0.04] px-8 py-12 sm:py-16 transition-colors duration-300 group-hover:bg-white/[0.07]">
                <img src={`${process.env.PUBLIC_URL}/media/sponsor-aperture.png`} alt="Aperture, official media sponsor" className="w-full max-w-[520px] h-auto" data-testid="media-sponsor-logo" />
              </div>
            </div>
          </a>
        </Reveal>
      </section>

      <PageHeader
        chapter="the memories"
        title="Photo gallery."
        sub={`288 photos from the ${EVENT.dateLabel} ${EVENT.shortName}, captured by Aperture. Tap any photo to view it large and download the full-resolution original.`}
        compact
      />

      <section className="mx-auto max-w-7xl px-5 sm:px-8 pb-24 sm:pb-32">
        <PhotoGrid />
      </section>
    </>
  );
}
